import { ChartData, ChartOptions, TooltipCallbacks } from 'chart.js'
import { FC } from 'react'
import { Doughnut } from 'react-chartjs-2'

type DoughnutChartProps = {
  data: ChartData<'doughnut'>
  tooltipCallbacks?: Partial<TooltipCallbacks<'doughnut'>>
  /**
   * Optional Chart.js options. Shallow-merged on top of the defaults, so a consumer
   * can override e.g. `maintainAspectRatio` when wrapping the chart in a CSS
   * `aspect-ratio` container to work around Chart.js v4 responsive sizing bugs.
   * (GR-2925, GR-2926)
   */
  options?: ChartOptions<'doughnut'>
}

export const DoughnutChart: FC<DoughnutChartProps> = ({ data, tooltipCallbacks, options: optionsOverride }) => {
  const options: ChartOptions<'doughnut'> = {
    responsive: true,
    // Debounce ResizeObserver callbacks to prevent infinite shrink/expand loop
    // at fractional browser zoom levels (e.g. 90% in Chromium on Windows). (GR-2925)
    resizeDelay: 200,
    ...optionsOverride,
    plugins: {
      legend: {
        position: 'bottom' as const,
        labels: {
          pointStyle: 'circle' as const,
          usePointStyle: true,
          padding: 32,
        },
      },
      tooltip: {
        position: 'average',
        yAlign: 'center',
        titleFont: {
          size: 14,
          weight: 'bolder' as const,
        },
        titleMarginBottom: 14,
        bodySpacing: 6,
        boxPadding: 6,
        usePointStyle: true,
        padding: 10,
        callbacks: tooltipCallbacks,
      },
    },
  }

  return <Doughnut data={data} options={options} />
}
